import { useEffect } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Box, Flex } from "@chakra-ui/react";

import DsrPostTextAreaInput from '../../forms/TextareaField/components/DsrPostTextAreaInput';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';
import { TfiWrite } from 'react-icons/tfi';
import { TbMessage2Question } from 'react-icons/tb';


function CreateDsrPostInputModal({
  dsrId,
  userActionRequired,
  handleCloseModal,
  handleCreateNewPost,
  showDsrModalLoader,
  showPostUploadImageOption,
  manageFaqProcessingCompleted,
  modalTransferPayloadRedux
}) {

  useEffect(() => {
    if (manageFaqProcessingCompleted === true) {
      handleCloseModal()
    }

  }, [manageFaqProcessingCompleted]);

  switch (userActionRequired) {
    case ('create-new-post'): {
      return (
        <LaunchdeckModal
          title={<Flex gap='1em' justify='flex-start' align='center'>
            <Box as={TfiWrite} color='white' boxSize="1em" />
            <Box color='white'>Write a post</Box>
          </Flex>}
          handleCloseModal={handleCloseModal}
          showModal={true}
          maxW='45em'
        >

          <Box w="100%" align="center" px='0.5em'>
            <DsrPostTextAreaInput
              userActionRequired={userActionRequired}
              name="createDsrPostContent"
              placeholder='Start a conversation here'
              htmlFor="createDsrPostContent"
              onClickCreatePost={handleCreateNewPost}
              dsrId={dsrId}
              showPostUploadImageOption={showPostUploadImageOption}
              isLoading={showDsrModalLoader}
            />
          </Box>

        </LaunchdeckModal>
      )
    }
    case ('create-faq-question'): {
      const { dsrId } = modalTransferPayloadRedux || {}
      return (
        <LaunchdeckModal
          title={<Flex gap='1em' justify='flex-start' align='center'>
            <Box as={TbMessage2Question} color='white' boxSize="1em" />
            <Box color='white'>Ask a question</Box>
          </Flex>}
          handleCloseModal={handleCloseModal}
          showModal={true}
          maxW='45em'
        >
          <Flex direction='column' justify='space-around' alignItems='center' w='100%' py='0.75em'>

            <Box w='100%' pb='1em' color='brandDark.500' fontSize='0.875em' lineHeight='1.25em' borderBottom='1px solid' borderBottomColor='gray.100'>
              <Flex w='100%' px='1em' justify='flex-start'>
                <Box px='1em'> Once it's answered, the response from a Host team member will be found on the Q&A page </Box>
              </Flex>
            </Box>

            {showDsrModalLoader === true ? <PageLoader /> :
              <Flex justify='center' w='100%'>
                <Box w="100%" align="center">
                  <DsrPostTextAreaInput
                    userActionRequired={userActionRequired}
                    name="createDsrPostQuestion"
                    placeholder='Type your question here'
                    fontSize='0.875em'
                    htmlFor="createDsrPostQuestion"
                    onClickCreatePost={handleCreateNewPost}
                    dsrId={dsrId}
                  />
                </Box>
              </Flex>
            }
          </Flex>

        </LaunchdeckModal>
      )
    }
    default: {
      console.log('There is no associated action with this user action:', userActionRequired)
      return null;
    }
  }

}

const mapStateToProps = (state) => ({
  manageFaqProcessingCompleted: state.manageDsrFaqContentOutcome?.results?.processingCompleted,
  modalTransferPayloadRedux: state.modalTransferPayloadRedux.results
})


export default withRouter(connect(mapStateToProps, null)(CreateDsrPostInputModal))